exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-3ef131e0],\r\n.fade-leave-active[data-v-3ef131e0] {\r\n    transition: opacity 0.5s;\n}\n.fade-enter[data-v-3ef131e0], .fade-leave-to[data-v-3ef131e0] /* .fade-leave-active below version 2.1.8 */ {\r\n    opacity: 0;\n}\n.job-offers__no-results[data-v-3ef131e0] {\r\n    width: 100%;\r\n    text-align: center;\r\n    position: absolute;\n}\r\n", ""]);

// exports
